import axios from 'axios';

export const getLogin = async login => {
    return await axios.post('/api/sso-login', login, {
        headers: {
            'Content-Type': 'application/json'
        }
    });
}